import { defineMessages } from "react-intl";
import { BulkStatus } from "../../models/bulk-operation/types.js";
const localizedBulkStatus = defineMessages({
  [BulkStatus.Success]: {
    id: "bulkStatusSuccess",
    defaultMessage: "Success"
  },
  [BulkStatus.Warning]: {
    id: "bulkStatusWarning",
    defaultMessage: "Warning"
  }
});
export {
  localizedBulkStatus
};
//# sourceMappingURL=bulkStatus.js.map
